import Skeleton from 'react-loading-skeleton';
import _ from 'lodash';

/**
 * Renders the loading placeholder of the RMA address block, mapping a range of six entries onto full-height skeleton blocks. Takes no props, so the placeholder is identical for the shipping and returning addresses.
 *
 * @returns The skeleton markup for the address data block.
 */
const AddressDataSkeleton = () => (
  <div className="address-data-skeleton-container">
    {_.map(_.range(0, 6), (item) => (
      <div key={item} className="content-element">
        <Skeleton height="100%" />
      </div>
    ))}
  </div>
);

export default AddressDataSkeleton;
